import Campaign from "../../entities/campaign";

/**
 * Campaign actions
 *
 * Call order:
 *
 * CAMPAIGN_SAVE_QUEUE:	adds the item to the save queue
 * --> CAMPAIGN_SAVE:	modifies the state
 * --> CAMPAIGN_SAVE_SUCCESS: if all went well
 * --> CAMPAIGN_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail CAMPAIGN_SAVE_QUEUE is during the call to CAMPAIGN_SAVE,
 * as adding an item to the queue should never fail.
 */

export const CAMPAIGN_FETCH_ONE_QUEUE: any = 'CAMPAIGN_FETCH_ONE_QUEUE';
export const CAMPAIGN_FETCH_SUCCESS: any = 'CAMPAIGN_FETCH_SUCCESS';
export const CAMPAIGN_FETCH_FAILURE: any = 'CAMPAIGN_FETCH_FAILURE';
export const CAMPAIGN_FETCH_ONE_SUCCESS: any = 'CAMPAIGN_FETCH_ONE_SUCCESS';
export const CAMPAIGN_FETCH_ONE_FAILURE: any = 'CAMPAIGN_FETCH_ONE_FAILURE';

export const CAMPAIGN_SAVE: any = 'CAMPAIGN_SAVE';
export const CAMPAIGN_SAVE_QUEUE: any = 'CAMPAIGN_SAVE_QUEUE';
export const CAMPAIGN_SAVE_SUCCESS: any = 'CAMPAIGN_SAVE_SUCCESS';
export const CAMPAIGN_SAVE_FAILURE: any = 'CAMPAIGN_SAVE_FAILURE';

export const CAMPAIGN_SAVE_MANY: any = 'CAMPAIGN_SAVE_MANY';
export const CAMPAIGN_SAVE_MANY_QUEUE: any = 'CAMPAIGN_SAVE_MANY_QUEUE';
export const CAMPAIGN_SAVE_MANY_SUCCESS: any = 'CAMPAIGN_SAVE_MANY_SUCCESS';
export const CAMPAIGN_SAVE_MANY_FAILURE: any = 'CAMPAIGN_SAVE_MANY_FAILURE';

export const CAMPAIGN_REMOVE: any = 'CAMPAIGN_REMOVE';
export const CAMPAIGN_REMOVE_QUEUE: any = 'CAMPAIGN_REMOVE_QUEUE';
export const CAMPAIGN_REMOVE_SUCCESS: any = 'CAMPAIGN_REMOVE_SUCCESS';
export const CAMPAIGN_REMOVE_FAILURE: any = 'CAMPAIGN_REMOVE_FAILURE';

export const CAMPAIGN_RESTORE: any = 'CAMPAIGN_RESTORE';
export const CAMPAIGN_RESTORE_QUEUE: any = 'CAMPAIGN_RESTORE_QUEUE';
export const CAMPAIGN_RESTORE_SUCCESS: any = 'CAMPAIGN_RESTORE_SUCCESS';
export const CAMPAIGN_RESTORE_FAILURE: any = 'CAMPAIGN_RESTORE_FAILURE';

export const CAMPAIGN_RESTORE_MANY: any = 'CAMPAIGN_RESTORE_MANY';
export const CAMPAIGN_REMOVE_MANY: any = 'CAMPAIGN_REMOVE_MANY';

/* Fetch actions */
export const fetchCampaignSuccess = (campaigns: Campaign[], partial: boolean, lastFetch: number) => ({type: CAMPAIGN_FETCH_SUCCESS, campaigns, partial, lastFetch});
export const fetchCampaignFailure = (err: any) => {
		console.error('CampaignAction: fetchCampaignFailure', err);
		return {type: CAMPAIGN_FETCH_FAILURE, err};
};
export const fetchOneCampaignQueue = (campaignId: string) => ({type: CAMPAIGN_FETCH_ONE_QUEUE, campaignId});
export const fetchOneCampaignSuccess = (campaign: Campaign) => ({type: CAMPAIGN_FETCH_ONE_SUCCESS, campaign});
export const fetchOneCampaignFailure = (id: string, err: any) => {
		console.error('CampaignAction: fetchOneCampaignFailure', err);
		return {type: CAMPAIGN_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveCampaign = (campaign: Campaign) => {
    // console.debug('⮂ CAMPAIGN_SAVE action', campaign?.id);
    return {type: CAMPAIGN_SAVE, campaign};
}
export const saveCampaignQueue = (campaign: Campaign) => {
    // console.debug('⮂ CAMPAIGN_SAVE_QUEUE action', campaign?.id);
    return {type: CAMPAIGN_SAVE_QUEUE, campaign};
}
export const saveCampaignSuccess = (campaign: Campaign) => {
    // console.debug('⮂ CAMPAIGN_SAVE_SUCCESS action', campaign?.id);
    return {type: CAMPAIGN_SAVE_SUCCESS, campaign};
}
export const saveCampaignFailure = (campaign: Campaign, status: number, message: string) => {
    console.warn(`⮂ CAMPAIGN_SAVE_FAILURE error saving campaign: HTTP ${status}: ${message}`, campaign?.id);
    return {type: CAMPAIGN_SAVE_FAILURE, campaign, status, message};
};

/* SaveMany actions */
export const saveManyCampaigns = (campaigns: Campaign[]) => {
    // console.debug('⮂ CAMPAIGN_SAVE_MANY action', campaigns?.map(campaign => campaign?.id).join(','));
    return {type: CAMPAIGN_SAVE_MANY, campaigns};
}
export const saveManyCampaignsQueue = (campaigns: Campaign[]) => {
    // console.debug('⮂ CAMPAIGN_SAVE_MANY_QUEUE action', campaigns?.map(campaign => campaign.id).join(','));
    return {type: CAMPAIGN_SAVE_MANY_QUEUE, campaigns};
}

export const saveManyCampaignsSuccess = (campaigns: Campaign[]) => {
    // console.debug('⮂ CAMPAIGN_SAVE_MANY_SUCCESS action', campaigns?.map(campaign => campaign.id).join(','));
    return {type: CAMPAIGN_SAVE_MANY_SUCCESS, campaigns};
}
export const saveManyCampaignsFailure = (campaigns: Campaign[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_CAMPAIGNS_FAILURE Error saving campaigns: HTTP ${status}: ${message}`, campaigns?.map(campaign => campaign.id).join(','));
		return {type: CAMPAIGN_SAVE_MANY_FAILURE, campaigns, status, message};
};

/* Remove actions */
export const removeCampaign = (campaign: Campaign) => ({ type: CAMPAIGN_REMOVE, campaign });
export const removeCampaignQueue = (campaign: Campaign) => ({ type: CAMPAIGN_REMOVE_QUEUE, campaign });
export const removeCampaignSuccess = (campaign: Campaign) => ({ type: CAMPAIGN_REMOVE_SUCCESS, campaign });
export const removeCampaignFailure = (campaign: Campaign, status: number, message: string) => {
	console.error(`Redux: removeCampaignFailure Error removing campaign: HTTP ${status}: ${message}`);
	return ({ type: CAMPAIGN_REMOVE_FAILURE, campaign, status, message });
};

/* Restore actions */
export const restoreCampaign = (campaign: Campaign) => ({ type: CAMPAIGN_RESTORE, campaign });
export const restoreCampaignQueue = (campaign: Campaign) => ({ type: CAMPAIGN_RESTORE_QUEUE, campaign });
export const restoreCampaignSuccess = (campaign: Campaign) => ({ type: CAMPAIGN_RESTORE_SUCCESS, campaign });
export const restoreCampaignFailure = (campaign: Campaign, status: number, message: string) => {
	console.error(`Redux: restoreCampaignFailure Error restoring campaign: HTTP ${status}: ${message}`);
	return ({ type: CAMPAIGN_RESTORE_FAILURE, campaign, status, message });
};

/* RestoreMany actions */
export const restoreManyCampaigns = (campaigns: Campaign[]) => ({ type: CAMPAIGN_RESTORE_MANY, campaigns });

/* RemoveMany actions */
export const removeManyCampaigns = (campaigns: Campaign[]) => ({ type: CAMPAIGN_REMOVE_MANY, campaigns });